/* eslint-disable no-dupe-keys */
export default {
  discount_settlement: {
    name: '优惠结算',
    // 属性（一般与对象内容匹配）
    prop: {
      ev_charging_station_settlement: '站结算'
    },
    // 列表页字段（列控制使用，需要与列表页匹配）
    columns: {
      service_provider_id: '运营商',
      ev_charging_station_settlement_id: '站结算',
      order_id: '订单',
      net_income_amount: '净收入',
      sharing_rate_amount: 'ECMP渠道费',
      settled_at: '结算时间',
      charging_finished_at: '充电结束时间',
      ev_charging_station: '充电站',
      station_settlement: '站结算记录',
      order_amount: '订单金额',
      charging_discounts_amount: '优惠金额',
      third_party_sharing_fee_rate_amount: '第三方渠道费',
      transaction_fee_rate_amount: '交易手续费',
      merchant_discount_rate_amount: '商家让利金额',
      discountable: '优惠项目',
      order: '订单',
      created_at: '创建时间',
      paid_at: '支付时间'
    },
    // Enum的属性
    // Boolean的属性
    // 占位提示
    // 详情页标签
    detail_tags: {
      detail: '基本信息'
    },
    titles: {
      station_settlement: '优惠结算信息',
      discountable: '优惠项目'
    }
  }
}
